
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Typography, Menu, MenuItem, ListItemIcon, Fade } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/PeopleTwoTone";
import EditIcon from "@material-ui/icons/BorderColorTwoTone";
import LabelIcon from "@material-ui/icons/LabelTwoTone";
import CfdisIcon from "@material-ui/icons/ReceiptTwoTone";
import CustomerDocumentIcon from "@material-ui/icons/FolderSharedTwoTone";
import CustomerBalanceIcon from "@material-ui/icons/AccountBalanceWalletTwoTone";
import PaymentReportIcon from "@material-ui/icons/AssessmentTwoTone";

import translate from "../i18n/Translator";
import { Customer } from "../model/Customer";
import { AppContext } from "../context/AppContext";
import { getCustomerPaymentReportUrl } from "../api/CustomerAPI";

interface CustomerMenuProps {
    customer: Customer;
    anchor: HTMLElement | null;
    onClose(): any;
    onClassify(): any;
    onGetBalance(): any;
}

export default function CustomerMenu(props: CustomerMenuProps) {
    const context = useContext(AppContext);
    const [url, setUrl] = useState<string>();

    useEffect(() => {
        getCustomerPaymentReportUrl(context.session!.tenant!.id, props.customer.id).then(url => {
            setUrl(url);
        }).catch(error => {
        });
        // eslint-disable-next-line
    }, [props.customer]);

    return (
        <Menu
            id="customers-item"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
        >
            {context.isGranted("CustomersUpdate") &&
                <MenuItem button component={Link} to={`/customers/${props.customer.id}/edit`} onClick={props.onClose} dense>
                    <ListItemIcon>
                        <EditIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.edit")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CfdisRead") &&
                <MenuItem button onClick={props.onGetBalance} dense>
                    <ListItemIcon>
                        <CustomerBalanceIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.customer_balance")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CustomersRead") && url &&
                <MenuItem button onClick={props.onClose} dense component="a" href={url} target="_blank" rel="noopener noreferrer">
                    <ListItemIcon>
                        <PaymentReportIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.payment_report")}</Typography>
                </MenuItem>
            }
            {context.isGrantedAny(["TenantsCustomersUsersRead", "CustomersUsersRead"]) &&
                <MenuItem button component={Link} to={`/customers/${props.customer.id}/users`} onClick={props.onClose} dense>
                    <ListItemIcon>
                        <PeopleIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("users.title")}</Typography>
                </MenuItem>
            }
            {context.isGrantedAny(["CfdisRead"]) &&
                <MenuItem button component={Link} to={`/customers/${props.customer.id}/cfdis`} onClick={props.onClose} dense>
                    <ListItemIcon>
                        <CfdisIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("cfdis.title")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CustomersUpdate") &&
                <MenuItem button onClick={props.onClassify} dense>
                    <ListItemIcon>
                        <LabelIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.classify_customers")}</Typography>
                </MenuItem>
            }
            {context.isGranted("DocumentsRead") && props.customer.documents &&
                <MenuItem button component={Link} to={`/customers/${props.customer.id}/documents`} onClick={props.onClose} dense>
                    <ListItemIcon>
                        <CustomerDocumentIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.see_documents")}</Typography>
                </MenuItem>
            }
        </Menu>
    );

}